import { Component } from '@angular/core';

@Component({
  selector: 'app-cards-8',
  templateUrl: './cards-8.component.html'
})
export class Cards8Component {



    }
